// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"733":"d229b3e8","853":"5a074b93","2668":"34e002cc"}[chunkId] + ".chunk.css";
};